import { cloneVNode, computed, onBeforeMount } from 'vue'
import DynamicTable from '../DynamicTable/DynamicTable.vue'
import { useStore } from 'vuex'

export default {
    name: 'JobPostingsTable',
    components: {
        DynamicTable,
    },
    props: {
        numberOfResults: {
            type: Number,
            required: true,
        },
        apiUrl: {
            type: String,
            required: true,
        },
    },
    setup(props) {
        const store = useStore()

        const selectedFilter = computed(() => store.state.jobs.selectedFilter)

        const headers = computed(() => {
            const storeHeaders = store.state.jobs.headers
            storeHeaders.forEach((header) => {
                header.scope = 'col'
            })
            return storeHeaders
        })

        const rows = computed(() => {
            const array = []
            const storeRows = store.state.jobs.rows
            const redirectUrl = store.state.jobs.redirectUrl

            storeRows.map((row) => {
                const updatedRow = []
                row.map((cell) => {
                    updatedRow.push({
                        name: cell.name,
                        href: cell.reference ? `${redirectUrl}?jobId=${cell.reference}` : '',
                        styles: cell.styles ?? '',
                    })
                })
                array.push(updatedRow)
            })

            return array
        })

        const filters = computed(() => {
            return store.state.jobs.filters
        })

        const filterChanged = (e) => {
            const filter = e.target.value
            store.dispatch('jobs/selectedFilter', filter)
            updateUrl(filter)
            store.dispatch('jobs/filteredRows', {
                api: props.apiUrl,
                filter: filter,
            })
        }

        const updateUrl = (value) => {
            const url = new URL(window.location)
            url.searchParams.set("q", value)
            window.history.pushState({}, "", url)
        }

        onBeforeMount(() => {
            const validFilters = filters.value.flat().map(e => e.value);

            const queryString = window.location.search
            const urlParams = new URLSearchParams(queryString)
            var searchQuery = urlParams.get("q") ?? ""

            if(searchQuery != "" && !validFilters.includes(searchQuery)) { 
                searchQuery = ""
                updateUrl(searchQuery)
            }

            store.dispatch('jobs/selectedFilter', searchQuery)
            store.dispatch('jobs/filteredRows', {
                api: props.apiUrl,
                filter: searchQuery,
            })            
        })

        return {
            headers,
            rows,
            filters,
            selectedFilter,
            filterChanged,
        }
    },
}
